import { cloneDeep } from "lodash";

export const setSurveyEndTime = ({ schedule, endTime }) => {
  schedule.endTime = endTime;

  return cloneDeep(schedule);
};

export default setSurveyEndTime;
